/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Desc_Nfp_VerifiedInputs */

const en_desc_nfp_verified = /** @type {(inputs: Desc_Nfp_VerifiedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Your charity registration has been approved. Your badge is live.`)
};

const es_desc_nfp_verified = /** @type {(inputs: Desc_Nfp_VerifiedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`El registro de tu organización benéfica ha sido aprobado. Tu insignia está activa.`)
};

const fr_desc_nfp_verified = /** @type {(inputs: Desc_Nfp_VerifiedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`L'enregistrement de votre association a été approuvé. Votre badge est en ligne.`)
};

const de_desc_nfp_verified = /** @type {(inputs: Desc_Nfp_VerifiedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Die Registrierung deiner Wohltätigkeitsorganisation wurde genehmigt. Dein Badge ist live.`)
};

const id_desc_nfp_verified = /** @type {(inputs: Desc_Nfp_VerifiedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pendaftaran organisasi amal Anda telah disetujui. Lencana Anda sudah aktif.`)
};

/** @type {(inputs: Desc_Nfp_VerifiedInputs) => LocalizedString} */
const ja_desc_nfp_verified = en_desc_nfp_verified;

/** @type {(inputs: Desc_Nfp_VerifiedInputs) => LocalizedString} */
const zh_desc_nfp_verified = en_desc_nfp_verified;

/** @type {(inputs: Desc_Nfp_VerifiedInputs) => LocalizedString} */
const ar_desc_nfp_verified = en_desc_nfp_verified;

/** @type {(inputs: Desc_Nfp_VerifiedInputs) => LocalizedString} */
const it_desc_nfp_verified = en_desc_nfp_verified;

/** @type {(inputs: Desc_Nfp_VerifiedInputs) => LocalizedString} */
const ru_desc_nfp_verified = en_desc_nfp_verified;

/** @type {(inputs: Desc_Nfp_VerifiedInputs) => LocalizedString} */
const pt_desc_nfp_verified = en_desc_nfp_verified;

/** @type {(inputs: Desc_Nfp_VerifiedInputs) => LocalizedString} */
const ko_desc_nfp_verified = en_desc_nfp_verified;

/**
* | output |
* | --- |
* | "Your charity registration has been approved. Your badge is live." |
*
* @param {Desc_Nfp_VerifiedInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const desc_nfp_verified = /** @type {((inputs?: Desc_Nfp_VerifiedInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Desc_Nfp_VerifiedInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_desc_nfp_verified(inputs)
	if (locale === "es") return es_desc_nfp_verified(inputs)
	if (locale === "fr") return fr_desc_nfp_verified(inputs)
	if (locale === "de") return de_desc_nfp_verified(inputs)
	if (locale === "ja") return ja_desc_nfp_verified(inputs)
	if (locale === "zh") return zh_desc_nfp_verified(inputs)
	if (locale === "ar") return ar_desc_nfp_verified(inputs)
	if (locale === "id") return id_desc_nfp_verified(inputs)
	if (locale === "it") return it_desc_nfp_verified(inputs)
	if (locale === "ru") return ru_desc_nfp_verified(inputs)
	if (locale === "pt") return pt_desc_nfp_verified(inputs)
	return ko_desc_nfp_verified(inputs)
});